export default "__VITE_ASSET__DSdH_x6a__"